import axios from 'axios';

import { IntegrationConfig, IntegrationConfigResponse } from './types';
import { transformIntegrationConfig } from './utils';

const agent = axios.create({
  baseURL: process.env.INTEGRATION_CONFIG_SERVICE_API_URL,
});

export const fetchIntegrationConfig = (venueId: string): Promise<IntegrationConfig> =>
  agent
    .get<IntegrationConfigResponse>(`/integration-configs/${venueId}`)
    .then(res => transformIntegrationConfig(res.data));

export default agent;
